import React from 'react';

const ErrorIndicator = () => <div>Error!</div>;

export default ErrorIndicator;
